import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconTower: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"tower, terminal"} maskId="square-filled-radius-0-stroke-1-IconTower"><path d="M14.5 22H9.5V15.5H14.5V22Z" fill="currentColor"/><path d="M19 14.5H5L3 10H21L19 14.5Z" fill="currentColor"/><path d="M15 3H12.5V5H19L17 9H7L5 5H11.5V3H9V2H15V3Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconTower;
